import { render, staticRenderFns } from "./disclaimer-dialog.vue?vue&type=template&id=2b7a1260&scoped=true&"
import script from "./disclaimer-dialog.vue?vue&type=script&lang=js&"
export * from "./disclaimer-dialog.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer-dialog.vue?vue&type=style&index=0&id=2b7a1260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a1260",
  null
  
)

export default component.exports